import React from 'react'
import { Box, Heading, Link, Text, Flex, useColorModeValue, Container , Icon} from '@chakra-ui/react'

import { ArrowTopRightOnSquareIcon } from '@heroicons/react/20/solid'

import NextImage from '../../components/shared/Image'
import SocialHead from '../../components/head/SocialHead'

import BlogAuthor from '../../components/blog/BlogAuthor'
import BlogTags from '../../components/blog/BlogTags'
import LinkBadge from '../../components/blog/LinkBadge'

import { getPostsWithPlaceholders } from '../../utils/client/blog'

export const getStaticProps = async () => {
	const fs = require('fs')
	const posts = await getPostsWithPlaceholders(fs)
	const postsSorted = posts.sort((a, b) => b.data.date - a.data.date)
	return { props: { posts: postsSorted } }
}

const ArticleList = ({posts}) => {
	const bgGradient = useColorModeValue('radial(orange.600 1px, transparent 1px)', 'radial(orange.300 1px, transparent 1px)')
	return (
		<>
		<SocialHead/>
		<Container maxW={'7xl'} p="12">
			<Flex marginBottom="100px" alignItems="center">
				<Heading as="h1">Blog Posts</Heading>
				<LinkBadge/>
			</Flex>
			{posts.map((c, i) =>
				<Box key={i} marginTop={{ base: '1', sm: '5' }} display="flex" flexDirection={{ base: 'column', sm: 'row' }} justifyContent="space-between" marginBottom="120px">
					<Box display="flex" flex="1" marginRight="3" position="relative" alignItems="center">
						<Box width={{ base: '100%', sm: '85%' }} zIndex="2" marginLeft={{ base: '0', sm: '5%' }} marginTop="5%">
							<NextImage borderRadius="lg" src={c.data.image} objectFit="cover" width={560} height={340} margin="0 auto" alt={c.data.description} placeholder="blur" blurDataURL={c.data.imageBlur} style={{height: 'auto'}}/>
						</Box>
						<Box zIndex="1" width="100%" position="absolute" height="100%">
							<Box bgGradient={bgGradient} backgroundSize="20px 20px" opacity="0.4" height="100%"/>
						</Box>
					</Box>
					<Box display="flex" flex="1" flexDirection="column" justifyContent="center" marginTop={{ base: '3', sm: '0' }}>
						<Flex marginBottom="12px">
							<BlogTags tags={c.data.tags}/>
						</Flex>
						<Heading marginBottom="12px">
							<Link href={`/blog/${c.slug}`}>{c.data.title}</Link>
						</Heading>
						<BlogAuthor name={c.data.author} image={c.data.authorImage} date={new Date(c.data.date)} marginBottom="12px"/>
						<Text marginBottom="12px" as="p" fontSize="lg">{c.data.description}</Text>
						<Link href={`/blog/${c.slug}`} display="flex" alignItems="center"><Text fontWeight="semibold">READ ON</Text><Icon as={ArrowTopRightOnSquareIcon} marginLeft="6px"/></Link>
					</Box>
				</Box>)}
		</Container>
		</>
	)
}

export default ArticleList